import React, { FormEvent } from "react";
import { api, IncomeTypeDto } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Entity, Error, LoadingDots, Modal } from "shared/ui";

export interface IIncomeTypeDeleteModal extends UseModalProps {
  companySlug: string;
  data: IncomeTypeDto;
}

export const IncomeTypeDeleteModal = (props: IIncomeTypeDeleteModal) => {
  const incomeTypeList = api.incomeType.useIncomeTypeList(props.companySlug);
  const submit = useApiMethod(api.incomeType.incomeTypeArchive);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await submit.call(props.companySlug, props.data.id);
    await incomeTypeList.mutate();
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={400}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Удалить тип дохода</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Entity>
            <Entity.Field title={props.data.name} />
          </Entity>

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Назад
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Удалить" : <LoadingDots size={4}>Удаляем</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

IncomeTypeDeleteModal.defaultProps = {};
